const constant = {
  prefixList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Professor"],
  genderList: ["Male", "Female", "Other"],
  phoneTypeList: ["Local", "International"],
  monthList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  livingAreaList: ["香港", "九龍", "新界"],
};

export { constant };
